module.exports = __webpack_public_path__ + "img/EDGE.9f769661.jpg";